<v4-custom-select
  [placeholder]="placeholder"
  [textItem]="textView"
  [showTextItem]="textView"
  [(visible)]="dropdownVisible"
>
  <div class="v4-layout-dropdown">
    <nz-range-picker
      nzInline
      [ngModel]="value"
      (ngModelChange)="onDatesChange($event)"
      [nzRenderExtraFooter]="footer"
    ></nz-range-picker>

    <ng-template #footer>
      <div class="range-extra-footer flex flex-row flex-wrap">
        <div
          class="item space-nowrap"
          *ngFor="let preset of presetRanges"
          (click)="onClickPreset(preset)"
        >
          {{ "component.search." + preset.label | translate }}
        </div>
      </div>
    </ng-template>
  </div>
</v4-custom-select>
